<!-- @let _receiptResults = receiptResults(); -->
<div
    class="SearchResultPage u-spacing-2xl-pt"
    [ngClass]="{ 'SearchResultPage--multiple-results': (receiptResults().data?.length ?? 0) > 1 }"
>
    <div class="SearchResultPage-title flex flex-middle u-spacing-xl-pb">
        <button ce-button-small ce-button-type-quaternary ce-button-icon (click)="navigateBackToLandingPage()">
            <ce-icon [svgIcon]="'arrowLeft'" />
        </button>
        <h1 class="u-text-title-lg">Your search results</h1>
    </div>

    @if (receiptResults()) {
    <!-- Display not found receipt when no results are found -->
    @if((receiptResults().data?.length ?? 0) === 0 && !receiptResults().loading && !receiptResults().error) {
    <div class="SearchResultPage-content">
        <lib-not-found-receipt />
    </div>
    } @if(receiptResults().data && (receiptResults().data?.length ?? 0) > 0 && !receiptResults().loading &&
    !receiptResults().error) {
    <!-- Display search results -->
    @if ((receiptResults().data?.length ?? 0) > 1) {
    <p class="SearchResultPage-matches u-text-body-lg">{{ receiptResults().data?.length }} matches</p>
    }

    <!-- Loop through each found receipt and display it -->
    @for (foundReceipt of (receiptResults().data ?? []); track foundReceipt) {
    <div class="SearchResultPage-content">
        <lib-found-receipt [receipt]="foundReceipt"></lib-found-receipt>
    </div>
    } } }
</div>
